import { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import DeleteIcon from 'assets/images/icons/delete.svg?react';
import { ProfileItem, ProfileSection } from 'entities/User';

const PASSPORT_URL = import.meta.env.VITE_PASSPORT_URL.split('/')
	.filter((key: string) => key !== 'personal-data')
	.join('/');

interface IProfileActionsProps extends HTMLAttributes<HTMLDivElement> {}

export const ProfileActions: FC<IProfileActionsProps> = ({ ...props }) => {
	const { t } = useTranslation();

	return (
		<ProfileSection {...props} title={t('Действия с аккаунтом')}>
			<ProfileItem
				label={t('Удаление аккаунта')}
				link={`${PASSPORT_URL}/security/delete-account`}
				buttonText={t('Удалить')}
				buttonColor="danger"
				buttonIcon={<DeleteIcon />}
			/>
		</ProfileSection>
	);
};
